<template lang="pug">
    section.main-tab
        ArticleOverridesNotice(v-if="!activeTranslation" :form="form" :kinds="['name', 'description', 'media', 'tags', 'other']")
        el-row.no-margin(:gutter="20")
            el-col(:sm="12")
                el-form-item(:label="$t('Name')" prop="name")
                    .translation-origin(
                        v-if="activeTranslation && form.translationOrigin.name"
                        :class="{ visible: showTranslationOrigin.includes('name') }"
                    )
                        button.language(type="button" @click="toggleTranslationOriginVisibility('name')")
                            span(v-if="showTranslationOrigin") {{ getLanguageName(defaultLanguage.code) }}
                            span(v-else) {{ $t('Show original text') }}
                            span.circle.fi.fis(:class="`fi-${defaultLanguage.flag || getLanguageFlag(defaultLanguage.code)}`")
                        transition(name="show-translation")
                            .translation-origin-content(
                                v-if="showTranslationOrigin.includes('name')"
                                v-html="form.translationOrigin.name"
                            )
                    el-input(v-model="name" maxlength="255" show-word-limit)
            el-col(:sm="12")
                el-form-item(:label="$t('URL Key')" prop="slug")
                    el-input(v-model="slug" maxlength="255" show-word-limit)
        el-row.no-margin(v-if="!activeTranslation" :gutter="60")
            el-col.flex-row(:lg="24" :md="24")
                el-form-item.grow(:label="$t('Product-Nr.')" prop="nr")
                    el-input(v-model="nr" maxlength="255" show-word-limit)
                el-form-item(
                    :label="$t('Relevance')"
                    prop="position"
                )
                    el-input-number(
                        v-model="position"
                        controls-position="right"
                        :disabled="activeTranslation"
                        :min="0"
                    )
                el-form-item(
                    v-if="sellsPhysicalGoods"
                    :label="$t('Shipping Points')"
                    prop="shipping_points"
                )
                    el-input-number(
                        v-model="shippingPoints"
                        controls-position="right"
                        :disabled="activeTranslation"
                        :min="0"
                    )
                el-form-item.status(:label="$t('Status')" prop="status")
                    el-select.is-full-width(
                        v-model="status"
                        placeholder=""
                        :disabled="activeTranslation"
                    )
                        el-option(v-for="(item, key) in options.status.items" :key="key" :label="$t(item.label)" :value="item.value")
        el-row.no-margin(v-if="!activeTranslation && sellsPhysicalGoods" :gutter="20")
            el-col(:sm="12")
                el-form-item(:label="$t('Condition')" prop="condition")
                    el-select.is-full-width(
                        v-model="condition"
                        placeholder=""
                    )
                        el-option(v-for="(item, key) in options.condition.items" :key="key" :label="$t(item.label)" :value="item.value")
            el-col(:sm="12")
                el-form-item(:label="$t('Brand')" prop="brand")
                    el-input(
                        v-model="brand"
                        maxlength="70"
                        show-word-limit
                    )
        el-form-item(:label="$t('Teaser')")
            //- el-input(v-model="teaser" type="textarea" :autosize="{ minRows: 3, maxRows: 40 }")
            .translation-origin(
                v-if="activeTranslation && form.translationOrigin.teaser"
                :class="{ visible: showTranslationOrigin.includes('teaser') }"
            )
                button.language(type="button" @click="toggleTranslationOriginVisibility('teaser')")
                    span(v-if="showTranslationOrigin") {{ getLanguageName(defaultLanguage.code) }}
                    span(v-else) {{ $t('Show original text') }}
                    span.circle.fi.fis(:class="`fi-${defaultLanguage.flag || getLanguageFlag(defaultLanguage.code)}`")
                transition(name="show-translation")
                    .translation-origin-content.ql-editor(
                        v-if="showTranslationOrigin.includes('teaser')"
                        v-html="form.translationOrigin.teaser"
                    )
            quill-editor(v-model="teaser" :options="quillConfig")
        el-form-item(:label="$t('Full Description')")
            //- el-input(v-model="description" type="textarea" :autosize="{ minRows: 3, maxRows: 40 }")
            .translation-origin(
                v-if="activeTranslation && form.translationOrigin.description"
                :class="{ visible: showTranslationOrigin.includes('description') }"
            )
                button.language(type="button" @click="toggleTranslationOriginVisibility('description')")
                    span(v-if="showTranslationOrigin") {{ getLanguageName(defaultLanguage.code) }}
                    span(v-else) {{ $t('Show original text') }}
                    span.circle.fi.fis(:class="`fi-${defaultLanguage.flag || getLanguageFlag(defaultLanguage.code)}`")
                transition(name="show-translation")
                    .translation-origin-content.ql-editor(
                        v-if="showTranslationOrigin.includes('description')"
                        v-html="form.translationOrigin.description"
                    )
            quill-editor(v-model="description" :options="quillConfig")

        el-row.no-margin(v-if="sellsPhysicalGoods" :gutter="20")
            el-col.flex-row(:sm="24")
                el-form-item.grow(:label="$t('Unit')" prop="unit")
                    .translation-origin(
                        v-if="activeTranslation && form.translationOrigin.unit"
                        :class="{ visible: showTranslationOrigin.includes('unit') }"
                    )
                        button.language(type="button" @click="toggleTranslationOriginVisibility('unit')")
                            span(v-if="showTranslationOrigin") {{ getLanguageName(defaultLanguage.code) }}
                            span(v-else) {{ $t('Show original text') }}
                            span.circle.fi.fis(:class="`fi-${defaultLanguage.flag || getLanguageFlag(defaultLanguage.code)}`")
                        transition(name="show-translation")
                            .translation-origin-content(
                                v-if="showTranslationOrigin.includes('unit')"
                                v-html="form.translationOrigin.unit"
                            )
                    el-input(
                        v-model="unit"
                        maxlength="255"
                        show-word-limit
                        :placeholder="$t('I.e. Gramm, Liter, Bottle, etc.')"
                    )
                el-form-item(v-if="!activeTranslation" :label="$t('Unit Quantity')" prop="quantity")
                    el-input-number(
                        v-model="quantity"
                        controls-position="right"
                        :min="0.01"
                        :step="0.01"
                        :step-strictly="true"
                    )

        el-form-item(v-if="!activeTranslation" :label="$t('Categories')")
            //- :flat="true" — Ober- und Unterkategorien werden unabhängig voneinander gewählt
            Treeselect(
                v-model="categories"
                placeholder=""
                :multiple="true"
                :flat="true"
                :options="categoryOptions"
                :default-expand-level="Infinity"
                :close-on-select="false"
                :open-on-focus="true"
                :searchable="true"
                :normalizer="node => ({ label: node.name, ...node })"
                :clearable="false"
                :always-open="false"
            )
                label(
                    slot="option-label"
                    slot-scope="{ node }"
                ) {{ node.raw.name }}
                div(
                    slot="value-label"
                    slot-scope="{ node }"
                ) {{ getBreadcrumb(node.raw) }}
        .flex-row(v-if="!activeTranslation")
            el-form-item.pos-favorite(
                v-if="enabledExtensions.includes('shop:point-of-sale')"
                label=" "
                prop="pos_favorite"
            )
                el-button(
                    :plain="!posFavorite"
                    :type="posFavorite ? 'primary' : 'info'"
                    icon="el-icon-fa-bookmark fas"
                    @click="posFavorite = !posFavorite"
                ) {{ $t('Point Of Sale Favorite') }}
            el-form-item.grow(:label="$t('Tags')" prop="tags")
                el-select.is-full-width(
                    ref="tagSelect"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    value-key="id"
                    :placeholder="$t('Select tags')"
                    v-model="tags"
                    @change="$refs.tagSelect.blur()"
                )
                    el-option(
                        v-for="tag in [ ...options.tag.items, ...tags.filter(tag => !options.tag.items.some(el => el.id === tag.id)) ]"
                        :key="tag.id"
                        :label="tag.name"
                        :value="tag"
                    ) {{ tag.name }}
            el-form-item.indicators(:label="$t('Color indicators')" prop="indicators")
                nobr.el-loading-parent--relative
                    template(v-if="options.indicator.loading")
                        .el-loading-mask
                        .spinner
                    a.indicator.is-outlined(
                        v-for="indicator in options.indicator.items"
                        :class="[ indicator.type, { active: indicators.find(el => el.id === indicator.id) } ]"
                        href="#"
                        @click.prevent.stop="toggleIndicator(indicator)"
                    )
                        i.el-icon-fa-check.fas(v-if="indicators.find(el => el.id === indicator.id)")

        el-form-item(:label="$t('Media')" prop="media")
            //- Gallery + dropzone share one flex-wrap row: the dropzone is the last item,
            //- grows into the row's free space (wrapping to its own full-width row when the
            //- tiles fill the line) and matches the 150px tile height. It combines upload +
            //- "select from library", with the validation hint directly underneath — the
            //- same shape as the photo-album content section.
            draggable(
                v-if="media"
                v-model="media"
                draggable="li.media"
            )
                transition-group(name="fade" tag="ul" class="media no-style-list product-media__grid")
                    ProductMedium(
                        v-for="(media, index) in media"
                        :key="media.id"
                        :media="media"
                        :form="form"
                        :image-edit-enabled="hasImageEditFeature"
                        :generation-progress="generationProgressFor(media)"
                        @edit-image="openEditImage"
                    )
                    li.media-generating(
                        v-for="upload in uploadsInFlight"
                        :key="`__upload_${upload.uid}`"
                    )
                        el-progress(type="circle" :percentage="upload.percent" :width="84" color="#409EFF")
                        span.media-generating__label {{ upload.name }}
                    li.media-generating(v-if="videoGen.active" key="__media_generating")
                        el-progress(type="circle" :percentage="videoGen.progress || 0" :width="84" color="#6E26FF")
                        span.media-generating__label {{ $t('Generating AI video…') }}
                    li.media-add(v-if="!activeTranslation" key="__media_add")
                        el-upload.plus-box(
                            ref="upload"
                            drag multiple :action="uploadEndpoint"
                            accept="image/jpg, image/jpeg, image/png, video/mp4"
                            :show-file-list="false"
                            :before-upload="validateUpload"
                            :on-change="updateUploadHeaders"
                            :on-progress="uploadProgress"
                            :on-success="uploadSucceed"
                            :on-error="uploadFailed"
                            :headers="uploadHeaders"
                            :data="uploadData"
                        )
                            i.el-icon-plus
                            .el-upload__text(v-html="$t('upload.drop.plural')")
                            //- Integrated into the dropzone: opens the library / webcam dialog
                            //- instead of the file picker (stop the dragger's click → file dialog).
                            .media-add__actions
                                button.media-add__library(
                                    type="button"
                                    @click.stop.prevent="showLibraryDialog = true"
                                )
                                    i.el-icon-picture-outline
                                    span {{ $t('Select from library') }}
                                button.media-add__library.media-add__webcam(
                                    type="button"
                                    @click.stop.prevent="showWebcamDialog = true"
                                )
                                    i.el-icon-fa-camera.fas
                                    span {{ $t('Take photo') }}
                            .el-upload__tip(slot="tip") {{ $t('upload.validation', { filetypes: 'jpg/png/mp4', size: '50mb' }) }}
            .media-foot(v-if="media && media.length > 1")
                span.media-sort-hint
                    i.el-icon-d-caret
                    | {{ $t('Drag and drop to reorder files') }}
            .media-actions(v-if="!activeTranslation && hasVideoFeature")
                el-button(
                    type="primary"
                    icon="el-icon-fa-wand-magic-sparkles fas"
                    :disabled="!hasImages"
                    @click="showVideoDrawer = true"
                ) {{ $t('Generate AI Video') }}

        //- Single pick, like the content image fields: the multi-select mode selects a
        //- FILE, which cannot express picking one version out of a file's stack, and the
        //- gallery accepts repeated picks anyway. onProductLibrarySelected normalises a
        //- single value, so nothing downstream changes.
        image-library-dialog(
            :visible.sync="showLibraryDialog"
            :multiple="false"
            selection-type="media"
            @select="onProductLibrarySelected"
        )

        webcam-capture-dialog(
            :visible.sync="showWebcamDialog"
            @captured="webcamCaptured"
        )

        GenerateVideoDrawer(
            v-if="hasVideoFeature"
            :visible.sync="showVideoDrawer"
            :product="form"
            @generation-started="onVideoGenerationStarted"
            @completed="onGenerationCompleted"
        )
        GenerateImageEditDrawer(
            :visible.sync="showImageDrawer"
            :product="form"
            :source-image-id="imageEditSourceId"
            :upload-context="imageEditorUploadContext"
            @completed="onGenerationCompleted"
            @updated="onImageUpdated"
            @replaced="onImageReplaced"
            @update-image-alt="onImageAltUpdated"
            @update-image-ai-disclosure="onImageAiDisclosureUpdated"
            @update-image-ai-label-display="onImageAiLabelDisplayUpdated"
            @update-image-ai-source-type="onImageAiSourceTypeUpdated"
        )

        .flex-row(v-if="!activeTranslation")
            el-form-item.grow(:label="$t('Accessible by')" prop="restriction")
                el-select.is-full-width(placeholder="" v-model="restriction")
                    el-option(
                        v-for="restriction in restrictions"
                        :key="restriction.key"
                        :label="restriction.name"
                        :value="restriction.value"
                    )
            transition(name="slide-decent-left")
                el-form-item(v-if="['members', 'member-tags'].includes(restriction)" label=" ")
                    el-switch(
                        :active-text="$t('Any')"
                        :value="restriction === 'members'"
                        @change="toggleMemberRestriction"
                    )

        //- Multistore: per-store visibility opt-out on the shared shop —
        //- grouped with the access control above (both decide who sees it).
        el-form-item(
            v-if="!activeTranslation && siblingStores.length > 1"
            :label="$t('Hidden in stores')"
            prop="hiddenInCmsIds"
        )
            el-select.is-full-width(
                multiple
                clearable
                filterable
                placeholder=""
                v-model="hiddenInCmsIds"
            )
                el-option(
                    v-for="store in siblingStores"
                    :key="store.id"
                    :label="store.name"
                    :value="parseInt(store.id, 10)"
                )
            .help {{ $t('By default the product is visible in every store of the shared shop. Selected stores hide it from their listing and search.') }}

        //- § 312g BGB: products excluded from the right of withdrawal
        //- (custom-made goods, perishables, daily newspapers, sealed health
        //- items, lottery tickets, …). Default ON; flip OFF to exclude.
        el-form-item(v-if="!activeTranslation" prop="returnable")
            el-switch(
                v-model="returnable"
                :active-text="$t('Can be revoked (§ 312g BGB)')"
            )
            .help {{ revocationHint }}
        transition(name="slide-decent-vertical")
            el-form-item(
                v-if="!activeTranslation && restriction === 'member-tags'"
                :label="$t('Only members with the following tags can access this product')"
                prop="memberTags"
            )
                el-select.is-full-width(
                    ref="memberTagSelect"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    value-key="id"
                    :placeholder="$t('Select tags')"
                    v-model="memberTags"
                    @change="$refs.memberTagSelect.blur()"
                )
                    el-option(
                        v-for="tag in [ ...options.extensions.restrictedArea.memberTag.items, ...tags.filter(tag => !options.extensions.restrictedArea.memberTag.items.some(el => el.id === tag.id)) ]"
                        :key="tag.id"
                        :label="tag.name"
                        :value="tag"
                    ) {{ tag.name }}

        el-form-item(
            v-if="!activeTranslation"
            :label="$t('Related Articles')"
            prop="relatedArticles"
        )
            RelatedArticlesField(
                v-model="relatedArticles"
                :shop-id="activeCms.shop.id"
                :disabled="!!activeTranslation"
            )

        el-form-item(
            v-if="!activeTranslation && categoryPostFeatureEnabled"
            :label="$t('Category Post')"
        )
            el-select.is-full-width(
                v-model="selectedCategoryPost"
                filterable
                remote
                clearable
                value-key="id"
                :placeholder="$t('Find a category post ...')"
                :remote-method="findCategoryPosts"
                :loading="categoryPostOptions.loading"
            )
                el-option(
                    v-for="option in categoryPostOptions.items"
                    :key="option.id"
                    :label="option.title"
                    :value="option"
                )
                    span {{ option.title }}
                    small.text-gray(v-if="option.category")  — {{ option.category.name }}

        .indexed-at-info(v-if="!activeTranslation && indexedAt")
            span.label {{ $t('Last indexed at') }}:
            span.value {{ indexedAt }}
        .indexed-at-info.pending(v-if="!activeTranslation && indexDirtySince")
            span.label {{ $t('Indexing pending since') }}:
            span.value {{ indexDirtySince }}
</template>

<i18n>
{
    "de": {
        "Hidden in stores": "Ausgeblendet in Stores",
        "By default the product is visible in every store of the shared shop. Selected stores hide it from their listing and search.": "Standardmäßig ist das Produkt in jedem Store des geteilten Shops sichtbar. In den ausgewählten Stores wird es aus Listing und Suche ausgeblendet.",
        "Generating AI video…": "KI-Video wird generiert…",
        "URL Key": "URL Schlüssel",
        "Color indicators": "Farbmarker",
        "Relevance": "Relevanz",
        "Condition": "Zustand",
        "New": "Neu",
        "Refurbished": "Generalüberholt",
        "Used": "Gebraucht",
        "Brand": "Marke",
        "Shipping Points": "Versandpunkte",
        "Unit": "Einzeleinheit Name",
        "I.e. Gramm, Liter, Bottle, etc.": "z.B. Gramm, Liter, Flasche, etc.",
        "Unit Quantity": "Menge der Einzeleinheit",
        "Teaser": "Anreißer",
        "Full Description": "Vollständige Beschreibung",
        "Product-Nr.": "Produkt-Nr.",
        "Categories": "Kategorien",
        "Tags": "Tags",
        "Anyone": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Only members with the following tags can access this product": "Nur Mitglieder mit den folgenden Tags haben Zugang zu diesem Produkt",
        "Select tags": "Tags auswählen",
        "Point Of Sale Favorite": "Kassenfavorit",
        "Related Articles": "Verknüpfte Artikel",
        "Find an article ...": "Artikel suchen ...",
        "Accessible by": "Zugänglich von",
        "Media": "Medien",
        "Drag and drop to reorder files": "Dateien per Drag and Drop sortieren",
        "Generate AI Video": "KI-Video erstellen",
        "Select from library": "Aus Mediathek wählen",
        "Take photo": "Foto aufnehmen",
        "AI Edit Image": "Bild mit KI bearbeiten",
        "Category Post": "Kategorie-Beitrag",
        "Find a category post ...": "Kategorie-Beitrag suchen ...",
        "Last indexed at": "Zuletzt indiziert am",
        "Indexing pending since": "Indizierung ausstehend seit",
        "Can be revoked (§ 312g BGB)": "kann widerrufen werden (gem. § 312g BGB)",
        "Events with a fixed date are excluded from the right of withdrawal (§ 312g Abs. 2 Nr. 9 BGB). Turn this on only if you want to take tickets back voluntarily.": "Veranstaltungen mit festem Termin sind vom Widerrufsrecht ausgenommen (§ 312g Abs. 2 Nr. 9 BGB). Nur einschalten, wenn Tickets freiwillig zurückgenommen werden sollen.",
        "Value vouchers are not tied to a date and are normally revocable. Turn this off only if you have a reason to exclude them.": "Wertgutscheine sind an keinen Termin gebunden und in der Regel widerrufbar. Nur ausschalten, wenn es einen Grund für den Ausschluss gibt.",
        "Turn off for custom-made goods, perishables, daily newspapers, sealed health items, lottery tickets, etc. Excluded products cannot be selected in the storefront return flow or the admin Widerruf drawer.": "Für Maßanfertigungen, verderbliche Ware, Tageszeitungen, versiegelte Hygiene-Artikel, Lottoscheine etc. ausschalten. Ausgeschlossene Produkte können weder im Storefront-Widerruf noch im Admin-Widerruf ausgewählt werden."
    }
}
</i18n>

<script>
import _ from 'lodash';
import axios from 'axios';

import { language, languageFlag, languageNativeName, formatDate } from '@/filters'
import { ensureFreshToken } from '@/helpers'
import { parseISO } from 'date-fns'

import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useShopProductStore } from '@/stores';
import draggable from 'vuedraggable';
import uniqid from 'uniqid';

import store from '@/store'
import Treeselect from '@riophae/vue-treeselect';
import NestedSet from '@/nested-set-lib';
import PageApi from '@/store/api/cms/page';
import quillConfig from '@/quill/config';
import { withTextGenerationContext } from '@/quill/toolbar/textGeneration';

import ProductMedium from './Partials/ProductMedium';
import ArticleOverridesNotice from './Partials/ArticleOverridesNotice';
import WebcamCaptureDialog from './Partials/WebcamCaptureDialog';
import RelatedArticlesField from '@/extensions/shop/components/RelatedArticlesField';
import GenerateVideoDrawer from '@/extensions/generative-media/views/Drawers/GenerateVideoDrawer';
import GenerateImageEditDrawer from '@/extensions/generative-media/views/Drawers/GenerateImageEditDrawer';
import generativeMediaApi from '@/extensions/generative-media/store/api/generativeMedia';
import ImageLibraryDialog from '@/components/Page/Sections/Partials/ImageLibraryDialog';
import Echo from '@/echo';
import imageEditor from './Mixins/imageEditor';

export default {
    name: 'MainTab',
    mixins: [imageEditor],
    data() {
        quillConfig.modules.link.pages = this.getPageOptions;
        return {
            // mainPriceType: 'main',
            quillConfig: withTextGenerationContext(quillConfig, () => ({ type: 'product', id: this.form.id, title: this.form.name })),
            quillPostLinksFeatureEnabled: false,
            uploadData: {
                'context[type]': 'product'
            },
            restrictions: [
                {
                    key: 'anyone',
                    value: null,
                    name: this.$t('Anyone')
                },
                {
                    key: 'members',
                    value: 'members',
                    name: this.$t('Members')
                },
                {
                    key: 'guests',
                    value: 'guests',
                    name: this.$t('Guests')
                }
            ],
            categoryPostFeatureEnabled: false,
            categoryPostOptions: {
                items: [],
                loading: false
            },
            showTranslationOrigin: [],
            showVideoDrawer: false,
            showLibraryDialog: false,
            showWebcamDialog: false,
            productTaskChannelName: null,
            // In-progress AI video generation (drives the media-grid placeholder).
            videoGen: { active: false, progress: 0 },
            // In-progress AI image edits, keyed by image id (string) → progress percent.
            // Drives the minimal progress overlay on the affected image thumbnail —
            // image edits must NOT show the "Generating AI video" placeholder tile.
            imageGen: {},
            // Files currently being uploaded, keyed by el-upload's uid → percent. The
            // dropzone hides Element's own file list (`:show-file-list="false"`), so
            // without this an upload gave no feedback at all until the tile appeared.
            uploads: {}
        };
    },
    components: {
        ArticleOverridesNotice,
        Treeselect,
        ProductMedium,
        draggable,
        RelatedArticlesField,
        ImageLibraryDialog,
        WebcamCaptureDialog,
        GenerateVideoDrawer,
        GenerateImageEditDrawer
    },
    watch: {
        // Product-level AI-task subscription: so a generation's result lands in the
        // gallery even when the drawer is closed ("you can close this and come back").
        // The drawer alone unsubscribes on close, which dropped the completion.
        id: {
            immediate: true,
            handler(value) {
                this.subscribeProductTaskChannel(value);
            },
        },
        // The drawer shares the product channel and LEAVES it on close (which also drops
        // our listeners). Re-subscribe after it closes so a generation that finishes
        // while the drawer is closed still refreshes the gallery ("close and come back").
        showImageDrawer(open) {
            if (!open) {
                this.$nextTick(() => this.subscribeProductTaskChannel(this.id));
            }
        },
        restriction(value) {
            if (value === 'member-tags') {
                const i = this.restrictions.findIndex(el => el.key === 'members')
                if (i >= 0) {
                    this.$set(this.restrictions[i], 'key', 'member-tags')
                    this.$set(this.restrictions[i], 'value', 'member-tags')
                }
            } else {
                const i = this.restrictions.findIndex(el => el.key === 'member-tags')
                if (i >= 0) {
                    this.$set(this.restrictions[i], 'key', 'members')
                    this.$set(this.restrictions[i], 'value', 'members')
                }
            }
        }
    },
    computed: {
        uploadHeaders() {
            return {
                authorization: `Bearer ${useAuthStore().token}`,
                accept: 'application/json',
            }
        },
        // Stable order so tiles do not jump around as percentages tick up.
        uploadsInFlight() {
            return _.sortBy(Object.values(this.uploads), 'uid');
        },
        id() {
            return _.get(this.form, 'id');
        },
        nr: {
            get() {
                return _.get(this.form, 'nr', '');
            },
            set(value) {
                this.setNr(value);
            }
        },
        status: {
            get() {
                if (this.activeTranslation) return this.form.translationOrigin.status
                return _.get(this.form, 'status') || 'enabled';
            },
            set(value) {
                if (!this.activeTranslation) this.setStatus(value);
            }
        },
        /**
         * Whether this product is an actual thing. A coupon and an event ticket are entitlements:
         * they have no condition, no manufacturer, no unit and nothing to ship.
         */
        sellsPhysicalGoods() {
            return !['coupon', 'event'].includes(_.get(this.form, 'type'));
        },
        /**
         * Why the switch is where it is, in terms of the type being sold. The generic wording about
         * perishables and newspapers says nothing useful under a ticket.
         */
        revocationHint() {
            const type = _.get(this.form, 'type');

            if (type === 'event') {
                return this.$t('Events with a fixed date are excluded from the right of withdrawal (§ 312g Abs. 2 Nr. 9 BGB). Turn this on only if you want to take tickets back voluntarily.');
            }

            if (type === 'coupon') {
                return this.$t('Value vouchers are not tied to a date and are normally revocable. Turn this off only if you have a reason to exclude them.');
            }

            return this.$t('Turn off for custom-made goods, perishables, daily newspapers, sealed health items, lottery tickets, etc. Excluded products cannot be selected in the storefront return flow or the admin Widerruf drawer.');
        },
        condition: {
            get() {
                return _.get(this.form, 'condition') || 'new';
            },
            set(value) {
                this.setCondition(value);
            }
        },
        brand: {
            get() {
                return _.get(this.form, 'brand', '');
            },
            set(value) {
                this.setBrand(value);
            }
        },
        indicators() {
            return _.get(this.form, 'indicators') || []
        },
        name: {
            get() {
                return _.get(this.form, 'name', '');
            },
            set(value) {
                this.setName(value);
            }
        },
        slug: {
            get() {
                return _.get(this.form, 'slug', '');
            },
            set(value) {
                this.setSlug(value);
            }
        },
        teaser: {
            get() {
                return _.get(this.form, 'teaser', '');
            },
            set(value) {
                this.setTeaser(value);
            }
        },
        description: {
            get() {
                return _.get(this.form, 'description', '');
            },
            set(value) {
                this.setDescription(value);
            }
        },
        unit: {
            get() {
                return _.get(this.form, 'unit');
            },
            set(value) {
                this.setUnit(value);
            }
        },
        quantity: {
            get() {
                const quantity = _.get(this.form, 'quantity');
                return quantity == null ? undefined : quantity;
            },
            set(value) {
                if (value === 0) value = undefined;
                if (!this.activeTranslation) this.setQuantity(value);
            }
        },
        position: {
            get() {
                if (this.activeTranslation) return _.get(this.form.translationOrigin, 'position') || undefined;
                return _.get(this.form, 'position') || undefined;
            },
            set(value) {
                if (!value) value = null;
                if (!this.activeTranslation) this.setPosition(value);
            }
        },
        shippingPoints: {
            get() {
                if (this.activeTranslation) return _.get(this.form.translationOrigin, 'shipping_points') || undefined;
                return _.get(this.form, 'shipping_points') || undefined;
            },
            set(value) {
                if (!value) value = null;
                if (!this.activeTranslation) this.setShippingPoints(value);
            }
        },
        categories: {
            get() {
                const categories = _.get(this.form, 'categories') || [];
                return _.map(categories, 'id');
            },
            set(value) {
                const categories = value.map(id => ({ id }));
                if (!this.activeTranslation) this.setCategories(categories);
            }
        },
        selectedCategoryPost: {
            get() {
                return _.get(this.form, 'page');
            },
            set(value) {
                this.setPage(value);
            }
        },
        categoryOptions() {
            let tree = [];
            let items = _.get(this.options, 'category.items') || [];

            if (items.length) {
                items = _.cloneDeep(items);
                tree = NestedSet.createTree(items);
            }

            return tree;
        },
        media: {
            get() {
                let media = _.cloneDeep(this.form.media) || [];
                media = media.sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0));
                return media;
            },
            set(media) {
                this.sortMedia(media);
            }
        },

        hasVideoFeature() {
            return !!(_.get(this.activeCms, 'extensions') || []).find(extension => extension.key === 'product-video');
        },
        hasImageEditFeature() {
            return !!(_.get(this.activeCms, 'extensions') || []).find(extension => extension.key === 'ai-image-edit');
        },
        hasImages() {
            return this.media.some(item => item.type === 'image');
        },

        posFavorite: {
            get() {
                return _.get(this.form, 'pos_favorite', false);
            },
            set(value) {
                if (!this.activeTranslation) this.setPosFavorite(value);
            }
        },

        restriction: {
            get() {
                return _.get(this.form, 'restriction');
            },
            set(value) {
                if (!this.activeTranslation) this.setRestriction(value)
            }
        },
        returnable: {
            get() {
                // Default ON for products that pre-date the field (column
                // default also true; this is just belt-and-suspenders).
                const v = _.get(this.form, 'returnable');
                return v === false ? false : true;
            },
            set(value) {
                if (!this.activeTranslation) this.setReturnable(!!value);
            }
        },
        siblingStores() {
            return _.get(this.activeCms, 'shop.cmses') || [];
        },
        hiddenInCmsIds: {
            get() {
                return (_.get(this.form, 'hidden_in_cms_ids') || []).map(id => parseInt(id, 10));
            },
            set(value) {
                if (!this.activeTranslation) this.shopProductStore.setFormHiddenInCmsIds(value);
            }
        },
        tags: {
            get() {
                let tags = _.get(this.form, 'tags');
                return tags.map(tag => {
                    if (tag.id.startsWith('new:')) return tag.name
                    else return tag
                })
            },
            set(value) {
                let tags = []
                value.forEach(tag => {
                    if (typeof tag === 'string' || tag instanceof String) {
                        tags.push({
                            id: uniqid('new:'),
                            name: tag,
                        })
                    } else {
                        tags.push(tag)
                    }
                })

                if (!this.activeTranslation) this.setTags(tags)
            }
        },
        memberTags: {
            get() {
                let tags = _.get(this.form, 'memberTags');
                return tags.map(tag => {
                    if (tag.id.startsWith('new:')) return tag.name
                    else return tag
                })
            },
            set(value) {
                let memberTags = []
                value.forEach(tag => {
                    if (typeof tag === 'string' || tag instanceof String) {
                        memberTags.push({
                            id: uniqid('new:'),
                            name: tag,
                        })
                    } else {
                        memberTags.push(tag)
                    }
                })

                if (!this.activeTranslation) this.setMemberTags(memberTags)
            }
        },
        relatedArticles: {
            get() {
                return _.get(this.form, 'relatedArticles');
            },
            set(articles) {
                if (!this.activeTranslation) this.setRelatedArticles(articles)
            }
        },
        uploadEndpoint() {
            return `${this.setupStore.uploadEndpoint}/public/${this.activeCms.id}/shop`
        },
        languageOptions() {
            return _.get(this.activeCms, 'languages') || []
        },
        defaultLanguage() {
            return this.languageOptions.find(language => language.default)
        },
        activeTranslation() {
            if (this.form.translationOrigin) return this.form
        },
        setupStore() {
            return useSetupStore();
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        locale() {
            return this.setupStore.locale;
        },
        form() {
            return this.shopProductStore.form;
        },
        options() {
            return this.shopProductStore.options;
        },
        indexedAt() {
            var value = _.get(this.form, 'indexed_at');
            if (!value) return null;
            return formatDate(parseISO(value), this.$t('yyyy-MM-dd') + ', HH:mm:ss');
        },
        indexDirtySince() {
            var value = _.get(this.form, 'index_dirty_since');
            if (!value) return null;
            return formatDate(parseISO(value), this.$t('yyyy-MM-dd') + ', HH:mm:ss');
        },

    },
    methods: {
        // After an AI generation completes, refetch the product so the new media
        // (video/image) appears in the gallery without a manual reload. Also clear the
        // in-flight indicators — this path is reached from the drawer's `completed`
        // event too (its watchdog), which covers a missed form-channel broadcast.
        onGenerationCompleted() {
            this.videoGen = { active: false, progress: 0 };
            this.imageGen = {};
            const id = _.get(this.form, 'id');
            if (id) {
                this.shopProductStore.fetchProduct(id);
            }
        },
        // Subscribe to the product's generative-media channel at the FORM level (not just
        // the drawer) so a completed AI edit refreshes the gallery even if the drawer was
        // closed mid-generation. Persisted-image and (product-context) library edits
        // broadcast here; fresh-upload edits use a per-upload channel the drawer owns.
        subscribeProductTaskChannel(productId) {
            this.unsubscribeProductTaskChannel();
            if (!productId) return;
            // ONE-TIME init fetch, not polling: the websocket only delivers the NEXT
            // broadcast (the job emits one per ~5s poll tick), so after a page reload
            // the in-flight indicators were blank for a few seconds. Seed them from the
            // StatusLog; the channel events below take over from there.
            this.seedActiveGenerationState(productId);
            if (!Echo.client) Echo.initialize();
            this.productTaskChannelName = `generative-media.product.${productId}`;
            const channel = Echo.client.private(this.productTaskChannelName);
            // Track in-progress generations so the media grid reflects them — this lives
            // on the form (not the drawer), so it survives the drawer closing. The kind
            // decides the affordance: a VIDEO generation gets the placeholder tile (it
            // creates a NEW tile when done); an IMAGE edit shows a minimal progress
            // overlay on the edited image's existing thumbnail instead.
            channel.listen('.task:progress', (payload) => {
                const type = _.get(payload, 'type');
                const imageId = parseInt(_.get(payload, 'imageId'), 10) || null;
                if (imageId && type !== 'video') {
                    this.$set(this.imageGen, String(imageId), _.get(payload, 'progress', 0) || 0);
                } else if (type !== 'image-edit') {
                    this.videoGen = { active: true, progress: _.get(payload, 'progress', 0) || 0 };
                }
                // image-edit without an imageId (upload/library promotion not done yet):
                // no tile exists to decorate — the editor drawer shows the progress.
            });
            channel.listen('.task:completed', () => {
                this.videoGen = { active: false, progress: 0 };
                this.imageGen = {};
                this.onGenerationCompleted();
            });
            channel.listen('.task:failed', () => {
                this.videoGen = { active: false, progress: 0 };
                this.imageGen = {};
                this.onGenerationCompleted();
            });
        },
        // The video drawer dispatched a generation — show the placeholder right away,
        // before the first progress broadcast arrives.
        onVideoGenerationStarted() {
            this.videoGen = { active: true, progress: 0 };
        },
        async seedActiveGenerationState(productId) {
            try {
                const [imageTask, videoTask] = await Promise.all([
                    generativeMediaApi.activeTask(productId, null, null, null),
                    generativeMediaApi.activeTask(productId, null, null, null, 'video'),
                ]);
                const running = task => task && (task.status === 'pending' || task.status === 'processing');
                if (running(imageTask)) {
                    let data = {};
                    try {
                        data = JSON.parse(imageTask.data || '{}') || {};
                    } catch (parseError) {
                        data = {};
                    }
                    const imageId = parseInt(data.promoted_image_id, 10) || parseInt(data.source_image_id, 10) || null;
                    if (imageId) this.$set(this.imageGen, String(imageId), imageTask.progress || 0);
                }
                if (running(videoTask)) {
                    this.videoGen = { active: true, progress: videoTask.progress || 0 };
                }
            } catch (error) {
                // Best-effort seeding — the live websocket events take over regardless.
            }
        },
        // The running AI image edit's progress for this media tile, or null when its
        // image isn't being edited right now.
        generationProgressFor(media) {
            const imageId = _.get(media, 'image.id');
            if (!imageId) return null;
            const progress = this.imageGen[String(imageId)];
            return progress === undefined ? null : progress;
        },
        unsubscribeProductTaskChannel() {
            if (this.productTaskChannelName && Echo.client) {
                Echo.client.leave(this.productTaskChannelName);
                this.productTaskChannelName = null;
            }
        },
        toggleTranslationOriginVisibility(key) {
            if (this.showTranslationOrigin.includes(key)) this.showTranslationOrigin.splice(this.showTranslationOrigin.indexOf(key), 1);
            else this.showTranslationOrigin.push(key);
        },
        getLanguageName(code) {
            return language(code, this.locale ? this.locale.value : 'de')
        },
        getLanguageFlag(code) {
            return languageFlag(code)
        },
        getLanguageNativeName(code) {
            return languageNativeName(code)
        },
        async getPagesPaginated(searchString = '') {
            const categories = _.get(this.activeCms, 'config.template.categories') || [];
            let data = {
                filters: [{
                    "key": "title",
                    "like": searchString
                },
                {
                    "key": "cms",
                    "match": this.activeCms.id
                },
                {
                    "in": categories.map(el => el.key),
                    "key": "category_keys"
                }],
                variables: {
                    order: 'created_at',
                    direction: 'desc',
                    withCategory: true
                },
            };

            let pageData;
            await PageApi.fetchPagesPaginated(data).then(data => {
                pageData = data.items;
            });
            return pageData;
        },
        getBreadcrumb(category) {
            let breadcrumb = category.name;

            const items = _.get(this.options, 'category.items') || [];
            let ancestors = NestedSet.getAncestors(items, category);

            const validatedItems = NestedSet.validate(_.cloneDeep(items));
            ancestors = ancestors.filter(el => validatedItems.valid.IDs.includes(el.id));

            if (ancestors && ancestors.length) {
                ancestors = _.map(ancestors, 'name');
                breadcrumb = ancestors.join(' > ');
                breadcrumb += ` > ${category.name}`;
            }

            return breadcrumb;
        },
        async updateUploadHeaders() {
            // The computed uploadHeaders reads the store token; make sure it is fresh.
            await ensureFreshToken();
        },
        // el-upload reports progress per file; the dropzone hides its built-in list, so
        // these drive a tile of our own for each file in flight.
        uploadProgress(event, file) {
            this.$set(this.uploads, file.uid, {
                uid: file.uid,
                name: file.name,
                percent: Math.round(_.get(event, 'percent', 0)),
            });
        },
        clearUploadProgress(file) {
            const uid = _.get(file, 'uid');
            if (uid !== undefined) this.$delete(this.uploads, uid);
        },
        async validateUpload(file) {
            await this.updateUploadHeaders();
            if (file.size / 1024 / 1024 > 50) {
                // this.$message.error('Avatar picture size can not exceed 2MB!');
                this.$notify.error({
                    title: this.$t('upload.sizeExceeded'),
                    message: this.$t('upload.max', {
                        size: '50mb'
                    }),
                    iconClass: 'fas el-icon-fa-xmark',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
                // Reject, never `return false`: an async before-upload always returns a promise,
                // and Element aborts only on rejection - a resolved `false` uploads anyway.
                return Promise.reject();
            }
        },
        // Shared by the dropzone upload and the webcam capture: turns the upload
        // endpoint's JSON response into a local product-media entry.
        buildMediaFromUploadResponse(response) {
            const imageMimeTypes = ['image/jpeg', 'image/gif', 'image/png', 'image/webp'];
            const videoMimeTypes = ['video/mp4', 'video/mpeg', 'video/webm', 'video/quicktime'];

            let type = 'file';
            if (imageMimeTypes.includes(response.mime)) type = 'image';
            else if (videoMimeTypes.includes(response.mime)) type = 'video';

            let image, video, file;
            switch (type) {
                case 'file':
                    file = {
                        id: response.id,
                        name: response.name,
                        preferred_name: response.preferred_name,
                        mime: response.mime,
                        type: 'original',
                        upload: true
                    };
                    break;

                case 'image':
                    image = {
                        id: uniqid('new:'),
                        width: response.dimensions.width,
                        height: response.dimensions.height,
                        source: {
                            id: response.id,
                            name: response.name,
                            preferred_name: response.preferred_name,
                            mime: response.mime,
                            type: 'original',
                            upload: true
                        }
                    };
                    break;

                case 'video':
                    video = {
                        id: uniqid('new:'),
                        width: response.dimensions.width,
                        height: response.dimensions.height,
                        source: {
                            id: response.id,
                            name: response.name,
                            preferred_name: response.preferred_name,
                            mime: response.mime,
                            type: 'original',
                            upload: true
                        }
                    };
                    break;
            }

            return {
                id: uniqid('new:'),
                type,
                scope: 'product',
                position: this.form.media.length + 1,
                settings: {
                    show: {
                        list: !this.form.media.filter(el => el.type === 'image').length && type === 'image',
                        detail: true,
                        highlight: !this.form.media.filter(el => el.type === 'image').length && type === 'image',
                        disabled: false
                    }
                },
                image,
                video,
                file
            };
        },
        async uploadSucceed(response, data) {
            this.clearUploadProgress(data);

            const media = this.buildMediaFromUploadResponse(response);

            setTimeout(() => {
                this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(el => el.uid !== data.uid);
            }, 1000);

            this.addMedia(media);

            await this.updateUploadHeaders();
        },
        // Webcam capture dialog hands back a raw Blob (image/jpeg) — upload it the
        // same way ShippingPackage.vue posts a generated label: FormData + axios,
        // reusing uploadEndpoint/uploadHeaders so it goes through the same auth path
        // as the dropzone. Response shape is identical, so it reuses the same builder.
        async webcamCaptured(blob) {
            await this.updateUploadHeaders();

            const formData = new FormData();
            formData.append('file', blob, `webcam-${Date.now()}.jpg`);
            formData.append('context[type]', 'product');

            try {
                const response = await axios.post(this.uploadEndpoint, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        authorization: this.uploadHeaders.authorization
                    }
                });
                this.addMedia(this.buildMediaFromUploadResponse(response.data));
            } catch (err) {
                this.$notify.error({
                    title: this.$t('upload.notUploaded'),
                    message: this.$t('Take photo'),
                    iconClass: 'fas el-icon-fa-xmark',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            } finally {
                await this.updateUploadHeaders();
            }
        },
        async uploadFailed(err, file) {
            this.clearUploadProgress(file);
            await this.updateUploadHeaders();

            this.$notify.error({
                title: this.$t('upload.notUploaded'),
                message: _.get(file, 'name'),
                iconClass: 'fas el-icon-fa-xmark',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000
            });
        },
        getPageOptions() {
            let menus = _.get(this.activeCms, 'config.template.menus', []);
            menus = _.cloneDeep(menus).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0));

            const menuOptions = _.get(this.options, 'menu.items') || [];
            // const visibleOptgroups = menuOptions.filter(el => el.menuItems.length).length > 1;

            let tree = [];
            menus.forEach(menu => {
                let dir = { folder: menu.name, children: [] };
                let children = [];

                const menuOption = _.find(menuOptions, { key: menu.key });
                let items = _.get(menuOption, 'menuItems', []);

                if (items.length) {
                    items = _.cloneDeep(items);
                    children = NestedSet.createTree(items);
                }

                dir.children = children;
                if (children.length) tree.push(dir);
            });

            return tree;
        },
        toggleMemberRestriction(value) {
            if (value === true) this.restriction = 'members'
            else this.restriction = 'member-tags'
        },
        toggleIndicator(indicator) {
            const indicators = _.cloneDeep(this.indicators);
            const i = indicators.findIndex(el => el.id === indicator.id)
            if (i >= 0) {
                indicators.splice(i, 1);
            } else {
                indicators.push(indicator);
            }
            this.setIndicators(indicators);
        },
        setNr(value) {
            return this.shopProductStore.setFormNr(value);
        },
        setStatus(value) {
            return this.shopProductStore.setFormStatus(value);
        },
        setCondition(value) {
            return this.shopProductStore.setFormCondition(value);
        },
        setBrand(value) {
            return this.shopProductStore.setFormBrand(value);
        },
        setName(value) {
            return this.shopProductStore.setFormName(value);
        },
        setSlug(value) {
            return this.shopProductStore.setFormSlug(value);
        },
        setTeaser(value) {
            return this.shopProductStore.setFormTeaser(value);
        },
        setDescription(value) {
            return this.shopProductStore.setFormDescription(value);
        },
        setUnit(value) {
            return this.shopProductStore.setFormUnit(value);
        },
        setQuantity(value) {
            return this.shopProductStore.setFormQuantity(value);
        },
        setPosition(value) {
            return this.shopProductStore.setFormPosition(value);
        },
        setShippingPoints(value) {
            return this.shopProductStore.setFormShippingPoints(value);
        },
        setCategories(value) {
            return this.shopProductStore.setFormCategories(value);
        },
        setPage(value) {
            return this.shopProductStore.setFormPage(value);
        },
        findCategoryPosts(query) {
            if (!query && this.categoryPostOptions.items.length) return;
            this.categoryPostOptions.loading = true;
            const cms = this.activeCms;
            const categories = _.get(cms, 'config.template.categories') || [];
            PageApi.fetchPagesPaginated({
                pageInfo: { perPage: 100 },
                variables: {
                    order: 'created_at',
                    direction: 'desc'
                },
                filters: [
                    { key: 'title', like: query || '' },
                    { key: 'cms', match: cms.id },
                    { key: 'category_keys', in: categories.map(function (element) { return element.key; }) }
                ]
            })
            .then(function (data) {
                var items = _.get(data, 'items') || [];
                var current = _.get(this.form, 'page');
                if (current) items = _.uniqBy([current].concat(items), 'id');
                this.categoryPostOptions.items = items;
            }.bind(this))
            .finally(function () { this.categoryPostOptions.loading = false; }.bind(this));
        },
        setRestriction(value) {
            return this.shopProductStore.setFormRestriction(value);
        },
        setReturnable(value) {
            return this.shopProductStore.setFormReturnable(value);
        },
        setPosFavorite(value) {
            return this.shopProductStore.setFormPosFavorite(value);
        },
        setTags(value) {
            return this.shopProductStore.setFormTags(value);
        },
        setMemberTags(value) {
            return this.shopProductStore.setFormMemberTags(value);
        },
        setRelatedArticles(value) {
            return this.shopProductStore.setFormRelatedArticles(value);
        },
        setIndicators(value) {
            return this.shopProductStore.setFormIndicators(value);
        },
        addMedia(media) {
            return this.shopProductStore.addFormMedia(media);
        },
        // Add one or more images chosen from the media library as new product media —
        // the upload alternative. The library payload (new:file-library: + source) is
        // persisted by the product backend's library-selection branch on Save.
        onProductLibrarySelected(selection) {
            const picked = Array.isArray(selection) ? selection : [selection];
            picked.filter(Boolean).forEach((entry) => {
                // The picker offers images and videos, and says which it handed back.
                const kind = _.get(entry, 'kind') === 'video' ? 'video' : 'image';
                const payload = _.get(entry, 'payload', entry);
                const hasImage = (this.form.media || []).some(item => item.type === 'image');
                // Only an image can be the list/highlight picture, so a video never
                // claims those slots.
                const showsAsCover = kind === 'image' && !hasImage;

                const media = {
                    id: uniqid('new:'),
                    type: kind,
                    scope: 'product',
                    position: (this.form.media || []).length + 1,
                    settings: { show: { list: showsAsCover, detail: true, highlight: showsAsCover, disabled: false } },
                };

                if (kind === 'video') media.video = payload;
                else media.image = { ...payload, type: 'product-image' };

                this.addMedia(media);
            });
        },
        sortMedia(media) {
            return this.shopProductStore.sortFormMedia(media);
        }
    },
    created() {
        //>>> add quill config depending on template features
        const features = _.get(this.activeCms, 'config.template.features') || []
        this.quillPostLinksFeatureEnabled = !!features.find(el => el === 'quill:post-links');
        if (this.quillPostLinksFeatureEnabled) {
            if (!quillConfig.modules.link.types.includes('posts')) {
                quillConfig.modules.link.types.splice(1, 0, 'posts');
            }
            quillConfig.modules.link.posts = this.getPagesPaginated;
        }
        //<<<

        //>>> category post feature
        this.categoryPostFeatureEnabled = !!features.find(function (element) { return element === 'product:category-post'; });
        if (this.categoryPostFeatureEnabled) {
            this.findCategoryPosts('');
        }
        //<<<
    },
    beforeDestroy() {
        this.unsubscribeProductTaskChannel();
    },
};
</script>

<style lang="sass" scoped>
.ai-media-actions
    margin-top: 16px

// ===== Product media manager =====
// Gallery + dropzone in one flex-wrap row. The dropzone is the last item; it grows into
// the row's free space (wrapping to its own full-width row when the tiles fill the line).
// Tiles keep their natural 150px height (align-items: flex-start) so the dropzone's hint
// can sit beneath it without stretching the tiles.
::v-deep .product-media__grid
    display: flex
    flex-wrap: wrap
    align-items: flex-start
    gap: 8px
    margin: 0
    padding: 0
    // Neutralise ProductMedium's float/margins so the flex row aligns cleanly.
    > li
        float: none
        margin: 0

// In-progress AI video placeholder — a 150px tile matching the gallery, with a circular
// progress and a label. Lives in the grid so it's visible whether or not the drawer is open.
::v-deep .media-generating
    width: 150px
    height: 150px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    gap: 10px
    border: 1px dashed #6E26FF
    border-radius: 5px
    background: rgba(110, 38, 255, 0.04)
    .media-generating__label
        font-size: 12px
        line-height: 1.2
        text-align: center
        color: #6E26FF
        padding: 0 8px

// The dropzone tile — same .plus-box visual as everywhere. It GROWS into the row's free
// space and the dragger is pinned to the 150px tile height (a fixed height, not 100%,
// which would collapse when the dropzone wraps onto its own row). The validation hint and
// the integrated "select from library" action sit with it.
::v-deep .media-add
    flex: 1 1 260px
    min-width: 220px
    .el-upload
        display: block
        width: 100%
    .el-upload-dragger
        width: 100%
        height: 150px
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        gap: 8px
    // Combined affordances: a library shortcut and a webcam shortcut, side by side
    // inside the dropzone. Each opens its own dialog (the @click.stop in the template
    // keeps the file picker from firing).
    .media-add__actions
        display: flex
        align-items: center
        gap: 8px
        flex-wrap: wrap
        justify-content: center
    .media-add__library
        display: inline-flex
        align-items: center
        gap: 6px
        padding: 4px 12px
        border: 1px solid #dcdfe6
        border-radius: 4px
        background: #fff
        font-size: 12px
        line-height: 1.2
        color: #6E26FF
        white-space: nowrap
        cursor: pointer
        transition: border-color 0.15s ease, background-color 0.15s ease
        &:hover
            border-color: #6E26FF
            background-color: rgba(110, 38, 255, 0.06)
    // The validation hint, directly beneath the dropzone.
    .el-upload__tip
        margin-top: 6px
        font-size: 12px
        line-height: 1.4
        color: #c0c4cc

// .media-foot
//     margin-top: 8px

.media-sort-hint
    display: inline-flex
    align-items: center
    gap: 6px
    font-size: 12px
    line-height: 1.4
    color: #6b7280

// Secondary creation action (AI video) grouped below.
.media-actions
    display: flex
    align-items: center
    margin-top: 12px

// Shared inline hint style — small, muted gray. Explicit line-height
// because Element UI's el-form-item__content sets line-height to 36px
// (matches form-control height) which would inflate the hint otherwise.
.help
    display: block
    margin-top: 4px
    font-size: 12px
    line-height: 1.4
    color: var(--color-text-muted, #909399)

.text-gray
    font-weight: 400 !important
    color: $color-grey-text

.status
    margin-left: 2rem

.indicators
    margin-left: 1rem
    .el-loading-parent--relative
        display: flex
        align-items: center
        gap: 4px
        height: 36px

.indicator
    position: relative
    width: 24px
    height: 24px
    margin: 0
    i.fas
        position: absolute
        left: calc(50% - 0.45em)
        top: calc(50% - 0.45em)
        color: white
        font-size: 0.8em

.indexed-at-info
    margin-top: 20px
    font-size: 12px
    color: #909399
    .label
        font-weight: 500
    .value
        margin-left: 4px
    &.pending
        margin-top: 4px
        color: #e6a23c
</style>
